module.exports = __webpack_public_path__ + "media/images/sp/costumes/mv_shiromuku-ae68df8365be094db8ddb596cfe690ca.webp";